import { SubscriptionPlan } from '@aibees/shared/definition';
import { PlanMetadata } from './types';

type Key = 'include' | 'feature';

export function usePlanMetadata(plan?: SubscriptionPlan, key?: Key) {
  const metadata = Object.entries(plan?.metadata || {}).filter((i) =>
    i[0].includes(key || '')
  );
  const parsedMetadata: PlanMetadata[] = metadata.map((i) => {
    return JSON.parse(i[1]);
  });
  // TODO use lodash
  return parsedMetadata.sort((a, b) => {
    if (a.enable && !b.enable) return -1;
    if (b.enable && !a.enable) return 1;
    return 0;
  });
}
